import { useAuth } from './AuthContext';

/**
 * Dev-only one-click login shortcut. Renders ONLY on localhost and ONLY while
 * logged out. Calls the test-login endpoint (`GET /api/test/login`) which is
 * itself gated by `ENV_NAME ∈ {test,local}` + a shared secret and 404s in
 * prod/preview — so this never appears or works on the real domain.
 *
 * The secret below is the local dev default (matches `.dev.vars`); it is not a
 * production credential.
 */
const LOCAL_TEST_SECRET = 'local-test-login-secret';

function isLocalhost(): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
}

export function TestLoginButton() {
  const { user } = useAuth();
  if (user || !isLocalhost()) return null;

  const login = () => {
    const redirectTo = window.location.pathname + window.location.search;
    window.location.href =
      `/api/test/login?id=dev&secret=${encodeURIComponent(LOCAL_TEST_SECRET)}` +
      `&redirect_to=${encodeURIComponent(redirectTo)}`;
  };

  return (
    <button
      type="button"
      onClick={login}
      title="로컬 전용 테스트 로그인 (OAuth 우회)"
      style={{
        font: 'inherit',
        fontSize: '0.8rem',
        padding: '4px 10px',
        borderRadius: 6,
        border: '1px dashed currentColor',
        background: 'transparent',
        color: 'inherit',
        opacity: 0.85,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
      }}
    >
      🔧 Test Login
    </button>
  );
}
